import { getServerTime } from "@utils/fetch.js";
import { countTime } from '@utils/index.js'
export class CountDownBanner {
    constructor({el, clas}) {
        this.selector = {
            el: el,
            count_down: el.find('.count-down')
        }
        this.init()
    }
    async init() {
        const {data} = await getServerTime();
        const serverTime = new Date(data.datetime).getTime();
        const time = new Date(this.selector.el.data('time')).getTime()
        const el = this.selector.count_down
        if (time > serverTime) {
            el.addClass('count-down-flex')
            countTime(time, serverTime,  el.get(0), function() {
                el.get(0).remove()
            })
        }
    }
}
